import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { priceFormatter } from 'Utils'
import SvgIcon from 'Components/SvgIcon'

import {
  _ChartSummaryBlock,
  _Square,
  _Title,
  _TitleContainer,
  _Value,
  _Unit,
  _Percent,
  _Count,
  _PriceContainer,
  _InfoContainer,
  _PrintStats,
} from './styles'

const ChartSummaryBlock = ({
  title,
  value,
  lineColor,
  changePercent,
  count,
  offer,
  printStyle,
  className,
}) => {
  const offerText = offer === 'Sale' ? 'Sales' : 'Rents'
  if(!value && !changePercent) return null
  return (
    <_ChartSummaryBlock className={className}>
      <_TitleContainer>
        <_Square style={{ backgroundColor: lineColor }} />
        <_Title>{title}</_Title>
      </_TitleContainer>
      <_PrintStats data-test-id="valueContainer" forPrint={printStyle}>
        {
          value && (
            <_PriceContainer>
              <_Value data-test-id={'value'}>
                {priceFormatter(value)}
                <_Unit>{'/sqft'}</_Unit>
              </_Value>
            </_PriceContainer>
          )
        }
        <_InfoContainer
          data-test-id={'infoContainer'}
          increase={changePercent > 0}
          printStyle={printStyle}
        >
          <SvgIcon name={'#icon-arrow-percent-diff-v2'} width={11} height={16} />
          <_Percent>{`${Math.abs(changePercent || 0).toFixed(
            2,
          )}%`}
          </_Percent>
          {count !== null && count !== undefined && (
            <_Count data-test-id={'count'}>{`(${count} ${offerText})`}</_Count>
          )}
        </_InfoContainer>
      </_PrintStats>
    </_ChartSummaryBlock>
  )
}

ChartSummaryBlock.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  offer: PropTypes.string,
  changePercent: PropTypes.number,
  count: PropTypes.number,
  lineColor: PropTypes.string,
  printStyle: PropTypes.bool,
  className: PropTypes.string,
}

export default memo(ChartSummaryBlock)
